import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import {ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-password-confirm',
  standalone: true,
  imports: [MenubarModule,
    ToastModule,
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    SplitButtonModule,
    DividerModule,
    PasswordModule,
    ToastModule
  ],
  providers: [MessageService],
  templateUrl: './password-confirm.component.html',
  styleUrl: './password-confirm.component.scss'
})
export class PasswordConfirmComponent {

  @Input() user: string = '';
  information: any;
  // url = environment.apiStrapi;
  items: MenuItem[] | undefined;
  itemsPro: MenuItem[] | undefined;
  visible: boolean = false;
  strongPasswordRegx: RegExp = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;
  isTokenExpired: boolean = true;

  islogin: boolean = true;
  isNewUser: boolean = false;
  isPasswordForgotten: boolean = false;

  haveLower: boolean = false;
  haveUpper: boolean = false;
  haveNumber: boolean = false;
  haveLength: boolean = false;
  isValidPassword: boolean = false;


  password = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.pattern(this.strongPasswordRegx)]),
    passwordConfirm: new FormControl('', [Validators.required]),
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private messageService: MessageService
  ) {
  }

  ngOnInit() {
    console.log('vvv', this.user);

  }
  setPass(ev: any) {
    this.validatePassword();
    this.testStrength();
  }

  get infoRegister() {
    return {
      password: this.password.get('password'),
      passwordConfirm: this.password.get('passwordConfirm')
    };
  }
  setPassword() {
    this.validatePassword();
  }
  validatePassword() {
    this.isValidPassword = this.password.controls['password'].value == this.password.controls['passwordConfirm'].value;
  }

  testStrength() {
    let pass = this.password.controls['password'].value || '';
    let level = 0;

    if (/[a-z]{1,}/.test(pass)) {
      this.haveLower = true;
      level++;
    }
    if (/[A-Z]{1,}/.test(pass)) {
      this.haveUpper = true;
      level++;
    }
    if (/[0-9]{1,}/.test(pass)) {
      this.haveNumber = true;
      level++;
    }
    this.haveLength = pass.length >= 8;

    return level;
  }

  updatePassword() {
    let payload = {
      usrTkn: this.user,
      password: this.password.controls['password'].value
    }
    this.loginService.updatePassword(payload).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity:'success', summary: 'Cambio realizado', detail: res.message });
        setTimeout(() => {
          this.router.navigate(['/']);
        }, 1000);
      }, error: (error: any) => {
        console.log('error :', error);
        this.messageService.add({ severity: 'error', summary: 'Ocurrió un error', detail: error.error.message ?? error.message ?? error.error });
      }
    });
  }
}
